export enum FormAlertMessageKindDTO {
  Primary = 1,
  Neutral = 2,
  Warning = 3,
  Danger = 4,
}
